<!-- eslint-disable max-len -->
<template>
  <div class="container-custom-carrusels" :style="bgStyle">
    <div class="initial-text">
      Plan Integral de Beneficios <br />
      Conectamos contigo
    </div>
    <v-col cols="12" md="12" lg="12" sm="12" xs="12" class="margin-top-md">
      <carousel-3d
        :show-arrows="false"
        hide-delimiter-background
        space="218"
        perspective="0"
        @after-slide-change="onAfterSlideChange"
        @before-slide-change="onBeforeSlideChange"
        v-model="selectedCardIndex"
        width="250"
        height="362"
        :controls-visible="false"
        :controls-width="5"
        :controls-height="5"
        :clickable="false"
        class="carousel-container-mobile"
      >
        <slide
          v-for="(item, index) in itemsBenefits"
          :index="index"
          :key="item.index"
          :class="index === selectedCardIndex ? 'selected' : 'custom-card'"
        >
          <v-card width="250" height="362" :class="index === selectedCardIndex && 'selected'">
            <v-card-text>
              <v-row class="d-flex justify-center align-center">
                <div v-if="index === selectedCardIndex">
                  <!-- <v-img
                    :src="
                      require(`../../../assets/newlanding/Benefit/${item.icon}.svg`)
                    "
                    :style="{ 'max-width': item.maxWidth }"
                    class="transparent-image"
                  ></v-img> -->
                </div>
                <div v-if="index != selectedCardIndex">
                  <!-- <v-img
                    :src="
                      require(`../../../assets/newlanding/Benefit/${item.iconDisabled}.svg`)
                    "
                    :style="{ 'max-width': item.maxWidth }"
                    class="mb-5 mt-4 transparent-image"
                  ></v-img> -->
                </div>
              </v-row>
            </v-card-text>
            <div style="height: 100px">
              <v-row class="d-flex justify-center align-center">
                <h2 class="text-title text-center pa-2">{{ item.title }}</h2>
              </v-row>
              <v-row>
                <p class="text-description text-center">
                  {{ item.description }}
                </p>
              </v-row>
            </div>
            <v-img
              :src="require(`../../../assets/newlanding/Landing/pulso-amarillo.png`)"
              class="transparent-image"
            ></v-img>
          </v-card>
        </slide>
      </carousel-3d>
    </v-col>
    <div class="final-text" @click="redirect">Únete a nosotros/as y disfruta de esto y más</div>
  </div>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import fondoKonecta from "@/assets/newlanding/Landing/fondo-konecta-mobile.png";
export default {
  name: "BenefitsPage",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      selectedCardIndex: 0,
      itemsBenefits: [
        {
          icon: "connected",
          iconDisabled: "connecteddisabled",
          maxWidth: "116.36px",
          title: "Conectamos Contigo",
          description: "Programa con más de 100 Beneficios pensado en tu bienestar y el de tu familia.",
        },
        {
          icon: "hour",
          iconDisabled: "hourdisabled",
          maxWidth: "80px",
          title: "Horarios flexibles",
          description:
            "Tenemos diferentes horarios para que puedas adaptar a tu estilo de vida, ya sea que estudies o tengas otras actividades.",
        },
        {
          icon: "discounts",
          iconDisabled: "discountsdisabled",
          maxWidth: "83.49px",
          title: "Descuentos corporativos",
          description:
            "Disfruta descuentos en actividades de entretenimiento, belleza, deporte, educación, salud, viajes y más.",
        },
        {
          icon: "conventions",
          iconDisabled: "conventionsdisabled",
          maxWidth: "120px",
          title: "Convenios",
          description:
            "Accede a los mejores convenios corporativos por ser Talento Konecta, en categorías como: educación, salud y entretenimiento.",
        },
        {
          icon: "career",
          iconDisabled: "careerdisabled",
          maxWidth: "56.21px",
          title: "Línea de carrera",
          description:
            "Tienes diversas oportunidades para crecer dentro de la empresa, en diferentes posiciones, cuentas o campañas. El 75% de vacantes se cubren con personal interno.",
        },
      ],
    };
  },
  methods: {
    onAfterSlideChange(index) {
      this.selectedCardIndex = index;
    },
    onBeforeSlideChange(index) {
      this.selectedCardIndex = index;
    },
    redirect() {
      this.$router.push("/empleos");
    },
  },
  computed: {
    bgStyle() {
      return {
        backgroundImage: `url(${fondoKonecta})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_app.scss";
.initial-text {
  color: #ffffff;
  // font-family: "Barlow", sans-serif !important;
  font-weight: 700;
  text-align: center;
  font-size: 20px;
}
.final-text {
  background: #ffffff;
  margin: 0 auto;
  width: 70%;
  text-align: center;
  // font-family: "Barlow", sans-serif !important;
  color: #2800c8;
  margin-top: 30px;
  font-weight: 700;
}
.container-custom-carrusels {
  margin: 0 auto;
  padding: 30px 0px;
}
.content-color {
  background-color: $secondary-white;
  width: 100%;
}
.carousel-container {
  width: 100%;
}

.custom-card {
  border-radius: 20px;
  border: none;
  background: #2800c8;
  background-color: $step-gray-dark;
  box-shadow: 0px 8px 12px $step-black-dark;
  ::v-deep(.transparent-image .v-image__image--cover) {
    width: 150%;
    position: absolute;
    bottom: 0;
    margin-top: 40px !important;
    margin-left: -66px !important;
  }
  ::v-deep(.transparent-image .v-responsive__sizer) {
    padding-bottom: 110% !important;
  }
  .text-title {
    // filter: blur(3px);
    // font-family: "Barlow", sans-serif !important;
    color: #2800c8;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    background-color: $step-gray;
    // opacity: 0.1;
    // text-shadow: 0 0 10px $step-black-dark;
    margin-top: 10px;
  }
  .text-description {
    // filter: blur(3px);
    // font-family: "Barlow", sans-serif !important;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.4;
    background-color: $step-gray;
    // opacity: 0.2;
    // text-shadow: 0 0 10px $step-black-dark;
    margin-top: 22px;
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
}
.selected {
  background: #ffffff;
  border-radius: 20px;
  border: none;
  box-shadow: 0px 8px 12px $step-black-dark;
  ::v-deep(.transparent-image .v-image__image--cover) {
    width: 150%;
    position: absolute;
    bottom: 0;
    margin-top: 65px !important;
    margin-left: -66px !important;
  }
  ::v-deep(.transparent-image .v-responsive__sizer) {
    padding-bottom: 110% !important;
  }
  .text-title {
    // font-family: "Barlow", sans-serif !important;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #2800c8;
  }
  .text-description {
    // font-family: "Barlow", sans-serif !important;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.4;
    color: #111111;
    margin-top: 32px;
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
}
.text-title {
  // font-family: "Barlow", sans-serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
}
.text-description {
  // font-family: "Barlow", sans-serif !important;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.2;
}
@media (max-width: 688px) {
  .carousel-container {
    text-align: center;
  }
}
@media (max-width: 414px) {
  .margin-top-md {
    margin-top: -8px;
  }
}
@media (max-width: 360px) {
  .margin-top-md {
    margin-top: -50px;
  }
}
</style>
